(function () {
  'use strict';

  if (window.BroekFomoTimer) {
    window.BroekFomoTimer.refresh();
    return;
  }

  var config = document.getElementById('broek-campaign-config');
  if (!config) return;

  var endAt = Date.parse(config.getAttribute('data-end') || '');
  if (!Number.isFinite(endAt)) return;

  var HOUR = 60 * 60 * 1000;
  var DAY = 24 * HOUR;
  var stageClasses = [
    'broek-fomo-stage-standard',
    'broek-fomo-stage-72',
    'broek-fomo-stage-24',
    'broek-fomo-stage-6',
    'broek-fomo-stage-ended'
  ];
  var tickTimer = null;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parts(remaining) {
    var total = Math.max(0, Math.floor(remaining / 1000));
    var days = Math.floor(total / 86400);
    total -= days * 86400;
    var hours = Math.floor(total / 3600);
    total -= hours * 3600;
    var minutes = Math.floor(total / 60);
    var seconds = total - minutes * 60;
    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
  }

  function stageFor(remaining) {
    if (remaining <= 0) return 'ended';
    if (remaining <= 6 * HOUR) return 'last-6';
    if (remaining <= 24 * HOUR) return 'last-24';
    if (remaining <= 72 * HOUR) return 'last-72';
    return 'standard';
  }

  function stageClass(stage) {
    if (stage === 'last-72') return 'broek-fomo-stage-72';
    if (stage === 'last-24') return 'broek-fomo-stage-24';
    if (stage === 'last-6') return 'broek-fomo-stage-6';
    if (stage === 'ended') return 'broek-fomo-stage-ended';
    return 'broek-fomo-stage-standard';
  }

  function stageCopy(stage, remaining) {
    if (stage === 'ended') return 'OFFER ENDED';
    if (stage === 'last-6') return 'LAST CHANCE';
    if (stage === 'last-24') return 'LAST CHANCE';
    if (stage === 'last-72') return 'ONLY ' + Math.max(2, Math.ceil(remaining / DAY)) + ' DAYS LEFT';
    return 'LIMITED OFFER';
  }

  function eyebrowCopy(stage, remaining) {
    if (stage === 'ended') return 'OFFER ENDED';
    if (stage === 'last-6') return 'FINAL HOURS';
    if (stage === 'last-24') return 'ENDS TONIGHT';
    if (stage === 'last-72') return 'ONLY ' + Math.max(2, Math.ceil(remaining / DAY)) + ' DAYS LEFT';
    return 'LIMITED DENIM OFFER';
  }

  function heroCopy(stage, remaining) {
    if (stage === 'ended') return 'OFFER ENDED';
    if (stage === 'last-6') return 'FINAL HOURS';
    if (stage === 'last-24') return 'ENDS TONIGHT';
    if (stage === 'last-72') return 'ONLY ' + Math.max(2, Math.ceil(remaining / DAY)) + ' DAYS LEFT';
    var days = Math.floor(remaining / DAY);
    if (days >= 2) return days + ' DAYS LEFT';
    if (days === 1) return '1 DAY LEFT';
    return 'FINAL HOURS';
  }

  function timerText(remaining) {
    var value = parts(remaining);
    var clock = pad(value.hours) + 'H : ' + pad(value.minutes) + 'M : ' + pad(value.seconds) + 'S';
    return value.days > 0 ? pad(value.days) + 'D : ' + clock : clock;
  }

  function cleanAnnouncement() {
    document.querySelectorAll('[data-broek-fomo-countdown]').forEach(function (timer) {
      timer.remove();
    });
    document.querySelectorAll('.broek-fomo-message').forEach(function (message) {
      message.classList.remove('broek-fomo-message');
      message.removeAttribute('data-broek-fomo-stage');
      var copyNode = message.querySelector('[data-broek-fomo-offer-copy]');
      if (copyNode) copyNode.removeAttribute('data-broek-fomo-offer-copy');
      var nativeTimer = message.querySelector('.countdown-announcementBar');
      if (nativeTimer) nativeTimer.remove();
    });
  }

  function fixedBar() {
    return document.getElementById('broek-fomo-fixed-bar');
  }

  function applyRootStage(stage) {
    var root = document.documentElement;
    stageClasses.forEach(function (name) { root.classList.remove(name); });
    root.classList.add('broek-fomo-fixed-active');
    root.classList.add(stageClass(stage));
  }

  function update() {
    var remaining = endAt - Date.now();
    var stage = stageFor(remaining);
    var time = timerText(remaining);
    var bar = fixedBar();
    if (!bar) return;

    applyRootStage(stage);
    bar.setAttribute('data-broek-fomo-stage', stage);

    var stageNode = bar.querySelector('[data-broek-fomo-fixed-stage]');
    var nextStageCopy = stageCopy(stage, remaining);
    if (stageNode && stageNode.textContent !== nextStageCopy) stageNode.textContent = nextStageCopy;

    var lead = bar.querySelector('[data-broek-fomo-fixed-lead]');
    if (lead) lead.textContent = stage === 'ended' ? 'STATUS' : stage === 'last-6' ? 'FINAL HOURS' : stage === 'last-24' ? 'FINAL DAY' : 'ENDS IN';

    var timeNode = bar.querySelector('[data-broek-fomo-fixed-time]');
    var fixedTime = stage === 'ended' ? '00D : 00H : 00M : 00S' : time;
    if (timeNode && timeNode.textContent !== fixedTime) timeNode.textContent = fixedTime;

    var offerEyebrow = eyebrowCopy(stage, remaining);
    document.querySelectorAll('[data-broek-widget-timer]').forEach(function (timer) {
      var compact = stage === 'ended' ? 'OFFER ENDED' : 'ENDS IN ' + time;
      if (timer.textContent !== compact) timer.textContent = compact;
      timer.setAttribute('role', 'timer');
      timer.setAttribute('aria-live', 'off');
      var card = timer.closest('.broek-2j-offer__card');
      if (!card) return;
      card.setAttribute('data-broek-fomo-stage', stage);
      var eyebrow = card.querySelector('.broek-2j-offer__eyebrow');
      if (eyebrow && eyebrow.textContent !== offerEyebrow) eyebrow.textContent = offerEyebrow;
    });

    var heroLabel = heroCopy(stage, remaining);
    document.querySelectorAll('.sec__content-subheading').forEach(function (label) {
      var current = (label.textContent || '').replace(/\s+/g, ' ').trim();
      if (
        label.hasAttribute('data-broek-dynamic-offer-label') ||
        /^LIMITED\s+\d+\s*-\s*DAY\s+DENIM\s+OFFER$/i.test(current) ||
        current === 'DENIM OFFER — ENDS SOON'
      ) {
        label.setAttribute('data-broek-dynamic-offer-label', '');
        if (label.textContent !== heroLabel) label.textContent = heroLabel;
      }
    });
  }

  function scheduleTick() {
    clearTimeout(tickTimer);
    if (document.hidden) return;
    update();
    tickTimer = setTimeout(scheduleTick, 1020 - (Date.now() % 1000));
  }

  function refresh() {
    cleanAnnouncement();
    if (fixedBar()) document.documentElement.classList.add('broek-fomo-fixed-active');
    scheduleTick();
  }

  function boot() {
    refresh();
    setTimeout(refresh, 500);
    setTimeout(refresh, 1600);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearTimeout(tickTimer);
    } else {
      scheduleTick();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(refresh, 50);
  });

  window.BroekFomoTimer = { refresh: refresh, endAt: endAt };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();